import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToHash from './components/ScrollToHash';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Academics from './pages/Academics';
import Campuses from './pages/Campuses';
import CampusDetail from './pages/CampusDetail';
import Admissions from './pages/Admissions';
import StudentLife from './pages/StudentLife';
import Contact from './pages/Contact';
import Gallery from './pages/Gallery';
import FAQ from './pages/FAQ';
import StateSyllabus from './pages/StateSyllabus';
import CBSE from './pages/CBSE';
import ICSE from './pages/ICSE';
import Cambridge from './pages/Cambridge';
import PUCollege from './pages/PUCollege';
import DegreeCollege from './pages/DegreeCollege';
import Careers from './pages/Careers';
import NewsEvents from './pages/NewsEvents';

function App() {
  return (
    <Router>
      <div className="App">
        <ScrollToHash />
        <Navbar />
        <Routes>
          {/* Main Navigation Pages */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/academics" element={<Academics />} />
          <Route path="/campuses" element={<Campuses />} />
          <Route path="/campuses/:id" element={<CampusDetail />} />
          <Route path="/admissions" element={<Admissions />} />
          <Route path="/student-life" element={<StudentLife />} />
          <Route path="/contact" element={<Contact />} />
          
          {/* Additional Pages */}
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/news-events" element={<NewsEvents />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/academics/state-syllabus" element={<StateSyllabus />} />
          <Route path="/academics/cbse" element={<CBSE />} />
          <Route path="/academics/icse" element={<ICSE />} />
          <Route path="/academics/cambridge" element={<Cambridge />} />
          <Route path="/academics/pu-college" element={<PUCollege />} />
          <Route path="/academics/degree-college" element={<DegreeCollege />} />
          <Route path="/careers" element={<Careers />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;